import CustomObject from './CustomObject.js'

export default class Door extends CustomObject
{
    constructor(modelPath, position, id, rotation) {
        super(modelPath, position, id, rotation);
        this.type = "door";
        this.collisionAllowed = false;
        this.snappingAllowed = true;
        this.axesMove = [true, false, true]; // x, y
        
    }
}